var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"},[_c('div',{staticClass:"c-header-nav"},[_vm._v(" 目前登入者:"+_vm._s(_vm.headerBarInfo)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }